/* eslint-disable complexity */
import React, { useEffect, useState, useCallback } from 'react';

import moment from 'moment';
import Button from 'react-bootstrap/Button';
import CloseButton from 'react-bootstrap/CloseButton';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { apiGet, buildApiURL } from '@src/services/api';

export const InnerpagePromoBanner = () => {
    const [currentTime, setCurrentTime] = useState(moment());
    const [rediscoverData, setRediscoverData] = useState({});
    const [bannerClosed, setBannerClosed] = useState(window.localStorage.getItem('innerpage_banner_closed'));

    useEffect(() => {
        apiGet(buildApiURL('/api/v1/settings/promo_notification_banners')).then((response) => {
            const data = response.promo_notification_setting.setting_values;
            setRediscoverData(data);
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.error(error);
        });
    }, [setRediscoverData]);

    const handleCloseClick = useCallback(() => {
        setBannerClosed(true);
        window.localStorage.setItem('innerpage_banner_closed', true);
    }, [setBannerClosed]);

    if (!rediscoverData) {
        return null;
    }

    let isFirstPhase = false;
    let isSecondPhase = false;
    const publishDatetime = moment(rediscoverData.publish_datetime);
    const endDatetime = moment(rediscoverData.end_datetime);
    if (publishDatetime < currentTime && currentTime < endDatetime) {
        isFirstPhase = true;
    }

    const publishDatetime2 = moment(rediscoverData.second_publish_datetime);
    const endDatetime2 = moment(rediscoverData.second_end_datetime);
    if (publishDatetime2 < currentTime && currentTime < endDatetime2) {
        isSecondPhase = true;
    }

    const allowFirstPhase = rediscoverData.allow_first_phase;
    const allowSecondPhase = rediscoverData.allow_second_phase;
    const firstBannerEnabled = rediscoverData.innerpage_banner_enabled;
    const secondBannerEnabled = rediscoverData.second_innerpage_banner_enabled;
    const isSecondBannerShow = isSecondPhase && allowSecondPhase && secondBannerEnabled;
    const isFirstBannerShow = isFirstPhase && allowFirstPhase && firstBannerEnabled;
    const bannerEnabled = isFirstBannerShow || isSecondBannerShow;
    const isOverlapped = isFirstBannerShow && isSecondBannerShow;
    let bannerContent = null;
    let bannerUrl = null;
    let bannerUrlText = null;
    let bannerUrlEnabled = false;
    let bannerStartQuoteUrl = null;
    let bannerStartQuoteUrlText = null;
    let bannerStartQuoteUrlEnabled = false;
    if (isSecondBannerShow) {
        bannerContent = rediscoverData.second_innerpage_banner_content;
    } else if (isFirstBannerShow) {
        bannerContent = rediscoverData.innerpage_banner_content;
    }

    if (isSecondBannerShow && !isOverlapped) {
        bannerUrl = rediscoverData.second_innerpage_banner_url;
        bannerUrlText = rediscoverData.second_innerpage_banner_url_text;
        bannerUrlEnabled = rediscoverData.second_innerpage_banner_url_enabled;
    } else if (isFirstBannerShow) {
        bannerUrl = rediscoverData.innerpage_banner_url;
        bannerUrlText = rediscoverData.innerpage_banner_url_text;
        bannerUrlEnabled = rediscoverData.innerpage_banner_url_enabled;
        bannerStartQuoteUrl = rediscoverData.innerpage_banner_start_quote_url;
        bannerStartQuoteUrlText = rediscoverData.innerpage_banner_start_quote_url_text;
        bannerStartQuoteUrlEnabled = rediscoverData.innerpage_banner_start_quote_url_enabled;
    }

    const overlapMessage = rediscoverData.overlap_message;
    const isOverlapMsgShow = isOverlapped && overlapMessage;

    const countdownTimerEnabled = rediscoverData.countdown_timer_enabled;
    const timeBetween = moment.duration(endDatetime2.diff(currentTime));
    const isCountdownShow = countdownTimerEnabled && isSecondBannerShow && timeBetween > 0;
    const isMore24hours = timeBetween.asDays() > 1;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if (isCountdownShow) {
            const interval = setInterval(() => {
                setCurrentTime(moment());
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [isCountdownShow]);

    if (!bannerEnabled || bannerClosed) {
        return null;
    }

    return (
        <Col sm={12} className="no-gutters">
            <Row className="innerpage-banner">
                <Col>
                    <Row className={isCountdownShow ? '' : 'py-4'}>
                        <div className="innerpage-logo-container">
                            <div className="my-auto innerpage-logo-col">
                                <img src="/img/rediscover/foremost_logo.png" />
                            </div>
                            <div className="my-auto content-col">
                                <span className="content">{ bannerContent }</span>
                            </div>
                        </div>
                        {
                            isCountdownShow && (
                                <div className="my-auto countdown-col">
                                    <p id="countdown_timer" className="pr-2">
                                        <span className="timer">
                                            {
                                                isMore24hours && (
                                                    <>
                                                        <span>{Math.floor(timeBetween.asDays())}</span>
                                                        <span className="colon px-1">:</span>
                                                    </>
                                                )
                                            }
                                            <span>{timeBetween.hours() < 10 ? '0' + timeBetween.hours() : timeBetween.hours()}</span>
                                            <span className="colon px-1">:</span>
                                            <span>{timeBetween.minutes() < 10 ? '0' + timeBetween.minutes() : timeBetween.minutes()}</span>
                                            {
                                                !isMore24hours && (
                                                    <>
                                                        <span className="colon px-1">:</span>
                                                        <span>{timeBetween.seconds() < 10 ? '0' + timeBetween.seconds() : timeBetween.seconds()}</span>
                                                    </>
                                                )
                                            }
                                        </span>
                                        <span className="hints">
                                            {
                                                isMore24hours && (
                                                    <span className="hint pr-4">DAYS</span>
                                                )
                                            }
                                            <span className="hint pr-4 pl-1">HOURS</span>
                                            <span className="hint pl-2">MINUTES</span>
                                            {
                                                !isMore24hours && (
                                                    <span className="hint pl-4 pr-0">SECONDS</span>
                                                )
                                            }
                                        </span>
                                    </p>
                                </div>
                            )
                        }

                    </Row>
                    <Row>
                        <Col className="bottom-part">
                            <hr />
                        </Col>
                    </Row>
                    <Row>
                        <div className="my-auto overflow-col">
                            {
                                isOverlapMsgShow && (
                                    <p id="overlap_message">{overlapMessage}</p>
                                )
                            }
                        </div>
                        <div className="my-auto pb-1 actions-col">
                            {
                                bannerUrlEnabled && (
                                    <Button
                                        href={bannerUrl}
                                        variant="primary"
                                        color="white"
                                        size="lg"
                                        className="banner-btn"
                                        title={bannerUrlText}
                                        aria-label={bannerUrlText}
                                    >
                                        {bannerUrlText}
                                    </Button>
                                )
                            }
                            {
                                bannerStartQuoteUrlEnabled && (
                                    <Button
                                        href={bannerStartQuoteUrl}
                                        variant="primary"
                                        color="white"
                                        size="lg"
                                        className="banner-btn-quote ml-3"
                                        title={bannerStartQuoteUrlText}
                                        aria-label={bannerStartQuoteUrlText}
                                    >
                                        {bannerStartQuoteUrlText}
                                    </Button>
                                )
                            }
                        </div>
                    </Row>
                </Col>
                <CloseButton
                    aria-label="Hide"
                    variant="white"
                    className="close-btn"
                    onClick={handleCloseClick}
                />
            </Row>
        </Col>
    );
};

export default InnerpagePromoBanner;
